'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');

const Styles = styleEncapsulation.labelStyles("ContentSection", {
  root: (size) => [
    {
      maxWidth: 1280,
      margin: "0 auto"
    },
    styleEncapsulation.withModifier(size, {
      small: { padding: "0 var(--zds-space-12)" },
      medium: { padding: "0 var(--zds-space-20)" },
      large: { padding: "0 var(--zds-space-40)" }
    }[size])
  ]
});
const ContentSection = ({ children, size = "small" }) => react.jsx("div", { css: Styles.root(size), "data-zds": true }, children);

exports.ContentSection = ContentSection;
//# sourceMappingURL=ContentSection.cjs.js.map
